import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

import type { BaseConfluenceObjectFinalizePopupNonHookProps } from '@atlassian/rovo-platform-ui-components/confluence-object-finalize-popup/types';

export const LazyConfluenceObjectFinalizePopup: LazyExoticComponent<
	ComponentType<BaseConfluenceObjectFinalizePopupNonHookProps>
> = lazy(() =>
	import(
		/* webpackChunkName: "@atlassian/conversation-assistant/confluence-object-finalize-popup" */ './index.tsx'
	).then((m) => ({ default: m.ConfluenceObjectFinalizePopup })),
);
